import List from './List.vue'
import Form from './Form.vue'

export default {
  install (Vue) {
    Vue.component('templates-list', List)
    Vue.component('templates-form', Form)
  }
}



// WEBPACK FOOTER //
// ./src/components/templates/index.js